import React, { useContext, useEffect } from 'react'
import { BlogContext } from './BlogContext'
import clsx from 'clsx'
import * as css from './BlogCategories.module.css'

const BlogCategories = () => {
	const { categories, set$category } = useContext(BlogContext)

	useEffect(() => {
		if (typeof window === 'undefined') return

		const params = new URLSearchParams(window.location.search)
		if (params.has('category')) {
			set$category(params.get('category'))
		}
	}, [])

	return (
		<section className={css.root}>
			<div className="p-4 flex items-center gap-2 overflow-x-auto">
				<Category />

				{categories?.map((category, key) => (
					<Category {...category} key={key} />
				))}
			</div>
		</section>
	)
}

const Category = ({ name }) => {
	const { $category, set$category, set$pagination } = useContext(BlogContext)

	function onClick() {
		set$pagination(0)
		set$category(name)
	}

	return (
		<button
			className={clsx(
				'_btn shrink-0 text-sm uppercase hover:text-orange transition-colors',
				name === $category && 'bg-orange !text-white'
			)}
			onClick={onClick}
		>
			{name || 'All'}
		</button>
	)
}

export default BlogCategories
